export const addHash = hash => hotel =>
	hash ? { ...hotel, path: `${hotel.path}${hash}` } : hotel;
